<template>
    <div>
        <div style=""></div>
        <div class="u-hd">
            <div class="hd-bk" @click="closeModle">
                <i class="icon iconback" ></i>&nbsp;返回
            </div>
            <div class="hd-tl">询价单列表</div>
            <div class="hd-mu">
            </div>
        </div>
        <div style="height:44px"></div>
        <div class="search">
            <div class="search-lst">
                <div class="search-lst-tag">
                    <div class="icon icondingdanhao"></div>
                    <div class="lst-tag-vle">
                        <input 
                        style="height:28px;border:0px solid #ccc;line-height:28px;" 
                        placeholder-class="placeholder"
                            v-model="input" placeholder="请输入标题" />
                    </div>
                </div>
                <div class="search-lst-tag" @click="$refs.selectTime.open()">
                    <div class="icon iconriqi"></div>
                    <div class="lst-tag-vle">
                        <div v-if="tabType=='0'">今日</div>
                        <div v-if="tabType=='1'">昨日</div>
                        <div v-if="tabType=='5'">前日</div>
                        <div v-if="tabType=='2'">近一周</div>
                        <div v-if="tabType=='3'">近一月</div>
                        <div v-if="tabType=='4'">自定义日期</div>
                    </div>
                </div>
            </div>
            <div class="search-lst">
                <div class="search-lst-tag" @click="$refs.selectPick.open()">
                    <div class="lst-tag-vle">
                        <div class="placeholder" v-if="!orderType.key">请选择单据状态</div>
                        <div v-else>{{orderType.text}}</div>
                    </div>
                </div>
                <div class="search-lst-tag" style="border-bottom:0px;">
                    <div class="search-btn-group">
                        <div class="search-btn" @click="goSearch">
                            <div class="icon iconsousuo"></div>
                            <div style="padding-left:10px;">查询</div>
                        </div>
                        <div style="width:1px;height:20px;background:#bbb"></div>
                        <div class="search-btn" @click="clearSearch">
                            <div class="icon iconzhongzhi"></div>
                            <div style="padding-left:10px;">重置</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="list">
            <van-empty v-if="!list || list.length<=0">
                <template slot="image">
                    <div style="text-align:center;margin-top:50px">
                        <i class="icon iconzanwushuju2" style="font-size:50px;color:#CCC"></i>
                    </div>
                    <div style="color:#CCC;text-align:center">暂无数据</div>
                </template>
            </van-empty>
            <mu-load-more @refresh="refresh" :loaded-all="isAllData" :refreshing="refreshing" :loading="loading" @load="load">
                <div class="ct-order" v-for="(item,index) in list" :key="item.id">
                    <div class="order-item">
                        <div class="item-icon">
                            <i class="icon icondanju" style="font-size: 25px;color:#4C37B6"></i>
                        </div>
                    </div>
                    <div class="order-box">
                        <div class="box-tl" style="display:flex;border-bottom: 1px solid #e8e8e8;">
                            <div style="width:calc(100% - 100px)">{{item.title}}</div>
                            <div style="width:100px;text-align:right;padding-right:15px;font-weight:500">
                                <span style="color:#ff862a" v-if="!item.hasBack">未处理</span>
                                <span style="color:#8bc34a" v-else>已处理</span>
                            </div>
                        </div>
                        <div style="display:flex">
                            <div class="box-text" style="flex:1">单据日期：<span style="color:#333">{{item.sendTime}}</span></div>
                        </div>
                        <div style="display:flex">
                            <div class="box-text" style="flex:1">客户名称：<span style="color:#333">{{item.merchantName}}</span></div>
                        </div>
                        <div style="display:flex">
                            <div class="box-text" style="flex:1">需求数量：<span style="color:#333">{{item.needCount}}</span></div>
                        </div>
                        <div class="box-btns">
                            <span class="btns-item" decode="true" @click="goDetail(item)" ><i class="icon icongengduo3"></i>&nbsp;查看详情</span>
                        </div>
                    </div>
                </div>
            </mu-load-more>
        </div>
        <select-time ref="selectTime" :type.sync="tabType" :typeText.sync="tabText" :st.sync="startTime" :et.sync="endTime"></select-time>
        <select-pick ref="selectPick" title="选择单据状态" :datas="options" :value-key="'key'" :label="'text'" :item.sync="orderType" ></select-pick>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    data() {
        return {
            tabType:'2',
            tabText:'近一周',
            startTime: '',
            endTime: '',
            input:'',
            options:[
                {
                    key:'1',
                    text:'未处理',
                },
                {
                    key:'2',
                    text:'已处理',
                }
            ],
            maxDate: new Date(),
            currentPage:1,
            list:[],
            orderType:{key:'',text:''},
            refreshing: false,
            loading: false,
            isAllData:false,
        };
    },
    mounted() {
        this.startTime=this.moment().subtract(7, 'days').format("YYYY-MM-DD")
        this.endTime=this.moment().format("YYYY-MM-DD")
        this.getData()
    },
    methods: {
        changeTabType(type) {
            this.tabType=type
            let startTime=''
            let endTime=''
            if (type == '0') {
                this.tabText='今日'
                startTime = this.moment().format("YYYY-MM-DD");
                endTime = this.moment().format("YYYY-MM-DD");
            } else if (type == '1') {
                this.tabText='昨日'
                startTime = this.moment().add(-1, 'days').format("YYYY-MM-DD");
                endTime = this.moment().add(-1, 'days').format("YYYY-MM-DD");
            } else if (type == '2') {
                this.tabText='近一周'
                startTime = this.moment().subtract(7, 'days').format("YYYY-MM-DD")
                endTime = this.moment().format("YYYY-MM-DD")
            } else if (type == '3') {
                this.tabText='近一月'
                endTime = this.moment().format("YYYY-MM-DD")
                startTime = this.moment().format("YYYY-MM-01")
            } else if (type == '4') {
                this.tabText='自定义数据'
                endTime = new Date(this.moment().format("YYYY-MM-DD"))
                startTime = new Date(this.moment().format("YYYY-MM-01"))
            }
            this.startTime=startTime
            this.endTime=endTime
            this.getData()
        },
        refresh () {
            this.refreshing = true;
            this.currentPage=1
            this.getData()
        },
        load () {
            this.loading = true;
            this.currentPage++;
            this.getData()
        },
        closeModle(){
            this.router.go(-1)
        },
        goDetail(id){
            this.selectId=id
            this.router.push({path:'/inquiryPriceDetail',query:{inquiryId:id.supplierInquiryId}})
        },
        goSearch(){
            this.refreshing=true
            this.currentPage=1
            this.getData()
        },
        clearSearch(){
            this.input=''
            this.orderType={key:'',text:''}
            this.startTime=this.moment().subtract(7, 'days').format("YYYY-MM-DD")
            this.endTime=this.moment().format("YYYY-MM-DD")
            this.tabType='2'
            this.tabText="近一周"
            this.getData()
        },
        getData(){
            this.$request.get("inquiry/findAllInquiry?pageNum="+this.currentPage+"&pageSize="+10+"&startTime="+this.startTime+"&endTime="+this.endTime).then(data=>{
                if(this.loading){
                   this.loading = false;
                   this.isAllData=false
                }
                if(this.refreshing){
                    this.refreshing = false;
                }
                if(data.status==200){
                    
                    if(this.currentPage<2){
                        this.list=data.content.content
                    }else{
                        this.list=this.list.concat(data.content.content)
                    }
                    if(this.currentPage>data.content.totalPages){
                        this.isAllData=true
                        Toast.success('数据加载完毕');
                        return;
                    }
                }
            })
        },
    },
};
</script>

<style scoped>
     .search{ 
        margin:10px 10px;
        /* border-radius: 10rpx; */
        padding:0px 15px 10px 15px;
        background: #FFF;
    }
        /* list搜索box每行样式 */
    .search-lst{
        display:flex;
        justify-content:space-between
    }
    /* list搜索框样式 */
    .search-lst-tag{
        width:48%;
        height:40px;
        line-height: 40px;
        padding-top:5px;
        display: flex;
        border-bottom:1px solid #eee
    }
        /* 搜索框图标样式 */
    .search-lst-tag .icon{
        font-size:18px;
        color:#aaa
    }
        /* 搜索框内容样式 */
    .lst-tag-vle{
        flex:1;
        text-align:center;
        color:#666;
        font-size:13px;
    }
    /* 搜索框未选中样式 */
    .lst-tag-vle .placeholder{
        color:#adadad;
        font-size:13px;
        text-align: left;
    }
        /* 搜索框按钮Box */
    .search-btn-group{
        width:100%;
        display:flex;
        border-radius:8rpx;
        background:#777;
        display:flex;
        align-items:center;
        justify-content:space-between
    }
        /* 搜索框按钮样式 */
    .search-btn{
        color:#fff;
        display:flex;
        width:49%;
        justify-content:center;
        font-size:14px;
    }
    .list{
        height: calc(100vh - 165px);
        overflow-y: auto;
        padding:0px 10px
    }
    .list .list-item{
        display: flex;
        background: #FFF;
        padding: 10px;
        margin-bottom: 10px;
    }
    .list .list-item .item-icon{
        width: 50px;
        text-align: center;
    }
    .list .list-item .item-icon .icon{
        font-size: 30px;
        color: #486AD8;
    }
    .list .list-item .item-ct .ct-tl{
        color: #486AD8;
        padding: 10px 0px;
        font-size: 16px;
    }
    .list .list-item .item-ct .ct-val{
        color: #666;
        font-size: 13px;
    }
  .ct-order{
    display: flex;
    background-color: #FFF;
    padding: 10px 0px;
    margin-bottom: 10px;
  }
  .ct-order .order-item{
    width: 40px;
    text-align: center;
  }
  .ct-order .order-item .item-icon text{
    color:#888;
    font-size: 30px
  }
  .ct-order .order-box{
    width: calc(100% - 40px);
  }
  .ct-order .order-box .box-tl{
    font-size: 14px;
    font-weight: 600;
    padding:5px 0px
  }
  .ct-order .order-box .box-text{
    font-size: 13px;
    padding: 4px 0;
    color: #888;
  }
  .ct-order .order-box .box-btns{
    border-top: 1px solid #e8e8e8;
    margin-top: 5px;
    padding: 3px 0px;
    text-align: right;
  }
  .ct-order .order-box .btns-item{
    font-size: 14px;
    padding: 5px 10px;
    margin-right:5px;
    display: inline-block;
    color:#4c37b6
  }
  .ct-order .order-box .box-btn{
    margin-top: 5px;
    width: 90%;
    color: #FFF;
    background-color:#486AD8;
    border-radius: 5px;
    padding: 8px 0px;
    margin-bottom:10px;
    font-size: 14px;
    text-align: center;
  }
  .ct-order .order-box .box-btn span{
    color: #FFF;
  }
  .ct-order .order-box .box-btn .icon{
    font-size: 15px
  }
  .custom-image .van-empty__image {
    width: 90px;
    height: 90px;
  }
</style>


// WEBPACK FOOTER //
// src/views/inquiryPrice/list.vue